import React from 'react';
import { useStore } from '../store/useStore';
import { CommunicationMetrics } from '../components/analytics/CommunicationMetrics';
import { DepartmentEngagement } from '../components/analytics/DepartmentEngagement';
import { TimelineChart } from '../components/analytics/TimelineChart';
import { KeyInsights } from '../components/analytics/KeyInsights';
import { motion } from 'framer-motion';

export const AnalyticsPage: React.FC = () => {
  const { messages, tasks, currentUser } = useStore();

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-6"
      >
        <div className="flex items-center gap-6">
          <img
            src={currentUser?.avatar}
            alt={currentUser?.name}
            className="w-16 h-16 rounded-full ring-4 ring-emerald-500 ring-offset-4"
          />
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Analytics Dashboard</h1>
            <p className="text-gray-600">Monitor communication metrics and engagement</p>
          </div>
        </div>
      </motion.div>

      <CommunicationMetrics messages={messages} tasks={tasks} />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TimelineChart messages={messages} tasks={tasks} />
        <DepartmentEngagement messages={messages} tasks={tasks} />
      </div>

      <KeyInsights messages={messages} tasks={tasks} />
    </div>
  );
};